import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Card, CardContent } from './ui/card';
import { CheckCircle2, Clock, FileText, Shield } from 'lucide-react';

const GuaranteesSection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-20 bg-gradient-to-br from-orange-100 via-pink-100 to-rose-200">
      <div className="container mx-auto px-4 max-w-6xl">
        {/* Guarantees */}
        <div className="mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-900 mb-12">
            {t('guarantees.title').split(' ').map((word, i) => {
              const highlight = ['Guarantees', 'garanties', 'garantías', 'garanzie'];
              return highlight.includes(word) ? 
                <span key={i} className="bg-gradient-to-r from-purple-600 via-violet-500 to-fuchsia-500 bg-clip-text text-transparent">{word} </span> : 
                word + ' ';
            })}
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <Card className="glass-card border-2 border-white/50 hover:border-purple-300 transition-all hover:shadow-lg">
              <CardContent className="p-6">
                <div className="w-12 h-12 mb-4 rounded-lg bg-purple-100 flex items-center justify-center">
                  <CheckCircle2 className="w-6 h-6 text-purple-600" />
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">
                  {t('guarantees.unlimited')}
                </h3>
                <p className="text-sm text-gray-700">
                  {t('guarantees.unlimitedDesc')}
                </p>
              </CardContent>
            </Card>

            <Card className="glass-card border-2 border-white/50 hover:border-cyan-300 transition-all hover:shadow-lg">
              <CardContent className="p-6">
                <div className="w-12 h-12 mb-4 rounded-lg bg-cyan-100 flex items-center justify-center">
                  <Shield className="w-6 h-6 text-cyan-600" />
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">
                  {t('guarantees.satisfaction')}
                </h3>
                <p className="text-sm text-gray-700">
                  {t('guarantees.satisfactionDesc')}
                </p>
              </CardContent>
            </Card>

            <Card className="glass-card border-2 border-white/50 hover:border-teal-300 transition-all hover:shadow-lg">
              <CardContent className="p-6">
                <div className="w-12 h-12 mb-4 rounded-lg bg-teal-100 flex items-center justify-center">
                  <Clock className="w-6 h-6 text-teal-600" />
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">
                  {t('guarantees.fast')}
                </h3>
                <p className="text-sm text-gray-700">
                  {t('guarantees.fastDesc')}
                </p>
              </CardContent>
            </Card>

            <Card className="glass-card border-2 border-white/50 hover:border-purple-300 transition-all hover:shadow-lg">
              <CardContent className="p-6">
                <div className="w-12 h-12 mb-4 rounded-lg bg-purple-100 flex items-center justify-center">
                  <FileText className="w-6 h-6 text-purple-600" />
                </div>
                <h3 className="font-semibold text-gray-900 mb-2">
                  {t('guarantees.free')}
                </h3>
                <p className="text-sm text-gray-700">
                  {t('guarantees.freeDesc')}
                </p>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* What You Receive & Delivery */}
        <div className="grid md:grid-cols-2 gap-8">
          <Card className="glass-card bg-gradient-to-br from-white/80 to-white/60 border-2 border-white/50 hover:shadow-xl transform hover:scale-105 transition-all duration-300">
            <CardContent className="p-8">
              <div className="w-14 h-14 mb-4 rounded-xl bg-gradient-to-br from-purple-600 via-violet-500 to-fuchsia-500 flex items-center justify-center shadow-lg">
                <FileText className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {t('receive.title')}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {t('receive.description')}
              </p>
            </CardContent>
          </Card>

          <Card className="glass-card bg-gradient-to-br from-white/80 to-white/60 border-2 border-white/50 hover:shadow-xl transform hover:scale-105 transition-all duration-300">
            <CardContent className="p-8">
              <div className="w-14 h-14 mb-4 rounded-xl bg-gradient-to-br from-cyan-600 to-teal-500 flex items-center justify-center shadow-lg">
                <Clock className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {t('delivery.title')}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {t('delivery.description')}
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default GuaranteesSection;
